import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { useTaskStatus } from 'components/projects/taskList/hooks';

const TaskCompleteCircle = styled.div`
  display: flex;
  flex: none;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  margin-top: 1px;
  border: 2px solid var(--cc_color_border_default);
  border-radius: 50%;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  background: var(--cc_color_utility_success);

  i {
    color: white;
    font-size: 16px;
  }
`;

const TaskIncompleteCircle = styled.div`
  flex: none;
  width: 22px;
  height: 22px;
  margin-top: 1px;
  border: 2px solid var(--cc_color_text_nonessential);
  border-radius: 50%;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? '0.25' : '1')};

  &:hover {
    border-color: var(--cc_color_text_subtle);
  }
`;

const CompleteTaskCircle = ({
  disabled,
  task,
  taskListId,
  hideCompletedTasks,
}) => {
  const { toggleTaskStatus } = useTaskStatus({
    taskId: task.id,
    taskListId,
    skipOptimisticUpdate: hideCompletedTasks,
  });
  const isCompleted = task.completed || false;
  const handleOnClick = () => (disabled ? () => {} : toggleTaskStatus(task));
  if (isCompleted) {
    return (
      <TaskCompleteCircle onClick={handleOnClick} disabled={disabled}>
        <i className="mdi mdi-check" />
      </TaskCompleteCircle>
    );
  }

  return <TaskIncompleteCircle onClick={handleOnClick} disabled={disabled} />;
};

CompleteTaskCircle.defaultProps = {
  disabled: false,
};

CompleteTaskCircle.propTypes = {
  disabled: PropTypes.bool,
  task: PropTypes.shape({
    id: PropTypes.string,
    completed: PropTypes.bool,
  }).isRequired,
  taskListId: PropTypes.string,
  hideCompletedTasks: PropTypes.bool,
};

export default CompleteTaskCircle;